import { cacheDom } from "../utils/QuerySelectors.js"
import { toggleModal } from "./Popup.js"
import { setupProduct } from '../sections/product.js'

const dom = {}
const qs = {
  productSection: 'data-section-type="main-product"',
  popup: 'data-popup',
}
const qsAll = {
  buttons: 'data-product-quickview',
}

const state = {
  tabs: null,
}

const updateTabs = (productData) => {
  if (productData) {
    const tabbedBlock = dom.popup.querySelector('.tabbed-block')
    const url = productData.url

    if (url && tabbedBlock) {
      getProTabsHTML(url)
        .then((result) => {
          var proTabs = document.createElement('div')
          proTabs.classList.add('station-tabs-tabset')
          proTabs.insertAdjacentHTML('beforeend', result)
          tabbedBlock.insertAdjacentElement('beforeend', proTabs)
          state.tabs.createInstance(tabbedBlock)
        })
        .catch(function (error) {
          console.log(error)
        })
    }

    setTimeout(() => {
      tabbedBlock.classList.remove('hide')
    }, 500)
  }
}

const getProTabsHTML = (url) => {
  return new Promise((resolve, reject) => {
    state.tabs.fetchElements(url, {
      queryString: '#station-tabs-data-json',
    })
      .then(function (result) {
        if (!result[0]) return
        var data = JSON.parse(result[0]?.textContent)
        resolve(data.proTabsHTML)
      })
      .catch(function (error) {
        reject(error)
      })
  })
}

export const setupQuickView = () => {
  cacheDom(dom, qs, qsAll)
  state.tabs = window.Station.Apps.Tabs
  dom.buttons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault()
      const productData = JSON.parse(button.dataset.productQuickview)
      if(typeof productData != 'undefined' && productData && productData.url) {
        button.disabled = true
        fetch(productData.url)
          .then(response => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html')
            const productSection = html.querySelector(`[${qs.productSection}]`)
            if(productSection) {
              toggleModal(true, null, productSection, true)
              setupProduct(productSection.dataset.sectionId)
              updateTabs(productData)
            }
            button.disabled = false
          })
          .catch((e) => {
            console.error(e)
            button.disabled = false
          })
      }
    })
  })
}